import { ReactElement } from 'react'
import { Box, useTheme } from '@mui/material'
import { FileListRow } from '@ui2/structure'
import { PDFAConformance } from '@editorComponents'
import PlanActionCell from '../PlanActionCell'

interface Props {
  plan: Plan
  selected: boolean
  onSelect: () => void
  onDelete: () => void
  onDuplicate: (plan: Plan) => void
  getBlobPDFA: (
    pdfUlr: string,
    conformance: PDFAConformance,
  ) => Promise<{ blob: Blob; errors: string[] } | null>
}

const PlanRow = ({
  plan,
  selected,
  onSelect,
  onDelete,
  onDuplicate,
  getBlobPDFA,
}: Props): ReactElement => {
  const theme = useTheme()

  return (
    <FileListRow
      icon={
        plan.local_isChanged ? (
          <Box
            title="Ungespeicherte Änderungen"
            sx={{
              minWidth: 10,
              height: 10,
              backgroundColor: theme.palette.warning.main,
              borderRadius: 5,
              flexShrink: 0,
            }}
          />
        ) : undefined
      }
      title={plan.node_name}
      subtitle={['PDF', plan.comment].filter(Boolean).join(' · ')}
      timestamp={plan.date ?? undefined}
      timestampFormat="time"
      selected={selected}
      onClick={onSelect}
      actions={
        <PlanActionCell
          plan={plan}
          onDelete={onDelete}
          onDuplicate={onDuplicate}
          getBlobPDFA={getBlobPDFA}
        />
      }
    />
  )
}

export default PlanRow
